import { useEffect } from 'react'

/**
 * Hook to scroll the main content container to top on component mount.
 * Useful for nested routes that share a persistent scroll container.
 */
export const useScrollToTop = (): void => {
  useEffect(() => {
    const scrollToTop = () => {
      // Find the main content container
      const mainEl = document.querySelector('main')
      if (mainEl) {
        if (typeof mainEl.scrollTo === 'function') {
          mainEl.scrollTo(0, 0)
        } else {
          mainEl.scrollTop = 0
        }
      }
    }

    // Defer scroll to ensure DOM is fully rendered
    const raf1 = requestAnimationFrame(() => {
      requestAnimationFrame(scrollToTop)
    })

    return () => cancelAnimationFrame(raf1)
  }, [])
}
